import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {prefix_lang} from "../../language/prefix";
import Swal from 'sweetalert2';
import { MyserviceService } from '../../provider/myservice.service';
import * as moment from 'moment';
@Component({
  selector: 'app-clear-payment',
  templateUrl: './prefix.component.html',
  styleUrls: ['./prefix.component.scss']
})
export class PrefixComponent implements OnInit {
  actions=[
    {id:0,action_type:{TH:"แสดงรายการข้อมูลคำนำหน้า",EN:"Prefix Data"},action_url:"name-prefix/get"},
    {id:1,action_type:{TH:"เพิ่มข้อมูลคำนำหน้า",EN:"Add Prefix Data"},action_url:"name-prefix/create"},
    {id:2,action_type:{TH:'แก้ไขข้อมูลคำนำหน้า',EN:"Edit Prefix Data"},action_url:"name-prefix/update"}
  ]
  all_prefix:any;
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  isLoading=true;
  action=this.actions[0];
  prefix={id:"",short_name:"",detail:"",manage_id:""}
  submitted=false;
  prefixs:any;
  constructor(private route:ActivatedRoute,router:Router,private service:MyserviceService) { }

  ngOnInit() {
    this.refreshData();

    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=prefix_lang[this.lang];
      }else{
        this.language=prefix_lang[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }

  onSearchFee_type(event){
    this.prefixs=this.all_prefix.filter((item)=>{
      if(item.id==""||item.short_name==""||item.detail==""||item.manage_id==""){
        return false;
      }else{
        return compare(item.id+"")||
        compare(item.short_name+"")||
        compare(item.description+"")||
        compare(item.manage_id+"")
      }
      function compare(type){
        //console.log(type);
        return type.toLowerCase().indexOf(event.target.value.toLowerCase())>-1;
      }1
    })

  }

  refreshData(){
    this.submitted=false;
    this.action=this.actions[0];
    this.isLoading=true;
    this.prefix={id:"",short_name:"",detail:"",manage_id:""}
    this.service.postData({},this.action.action_url).then((result:any)=>{
      this.isLoading=false;
      if (!result.code) {
        this.all_prefix = result.data.map((item) => {
          return item;
        });
        this.prefixs = this.all_prefix;
      }else{
        this.prefixs=[];
      }
    });
  }
  add(){
    this.service.postData({},"name-prefix/getId").then((result:any)=>{
      this.prefix.id=result.max_id;
    },err=>{

    })
    this.action=this.actions[1];
  }
  save(){
    this.submitted=true;

    if(this.prefix.short_name!=""&&this.prefix.detail!=""&&this.prefix.manage_id!=""){
      this.isLoading=true;
      this.service.postData(this.prefix,this.action.action_url).then((result:any)=>{
        if(result.code){
          Swal.fire({
            title:  this.language.saved,
            text: '',
            type: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer:2000
          }).then((result)=>{
               this.refreshData();
          })

        }else{

        }
        this.refreshData();
      },err=>{
        this.refreshData();
      })
    }
  }
  edit(item){
    this.prefix=item;
    this.action=this.actions[2];
  }
  delete(item) {
    Swal.fire({
      title: this.language.delete_place_alert,
      text: this.language.warning_delete,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.language.want_delete,
      cancelButtonText: this.language.close_page
    }).then((result) => {
      if (result.value) {
        // //console.log(place);
        this.isLoading=true;
        this.service.postData({ id:item.id }, "name-prefix/delete").then((result) => {
          Swal.fire({
          title: this.language.deleted,
          text: '',
          type: 'success',
          showCancelButton: false,
          showConfirmButton: false,
          timer:2000
        }).then((result) => {
            this.isLoading=false;
            this.refreshData();
          })
        }, err => {
          window.location.href=this.service.start_host
        })
      }
    })
  }
  back(){
    this.refreshData();
  }

}
